import { addQueryArgs } from '@wordpress/url';
import { getOrderParams } from '../mixins/property-list';
import { getParamsOfUrl, getUrl } from '../mixins/search';
import L from 'leaflet';
import { getMapBounds, addMarker, openPopup, closePopup } from '../../mixins/map';

let searchWithMapNode, mapPropertyNode, sortNode, containerNode, searchNode;

const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
let map;
let query = { offset: 1, orderby: 'date', order: 'DESC', has_coordinates: true, template: 'search_with_map' };

const realpressSearchWithMap = () => {
	searchWithMapNode = document.querySelector( '#realpress-search-with-map' );
	if ( ! searchWithMapNode ) {
		return;
	}

	mapPropertyNode = searchWithMapNode.querySelector( '#realpress-map-property-wrapper' );
	sortNode = searchWithMapNode.querySelector( '.realpress-sort-by select' );
	containerNode = searchWithMapNode.querySelector( '.realpress-property-container' );
	searchNode = searchWithMapNode.querySelector( '.realpress-advanced-search' );

	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}
	sort();
	if ( searchNode ) {
		search();
	}
	getProperties( query );
};

const getProperties = ( query = {} ) => {
	containerNode.style.opacity = 0.4;
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/property-list', query ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			containerNode.innerHTML = res.data.content;
			triggerPopup();
		} else if ( res.msg ) {
			containerNode.innerHTML = res.msg;
		}

		if ( res.data.property === undefined ) {
			handlePropertyMap( [] );
		} else {
			handlePropertyMap( res.data.property );
		}

		if ( res.data.pagination !== undefined ) {
			searchWithMapNode.querySelector( '.realpress-swm-pagination' ).innerHTML = res.data.pagination;
		} else {
			searchWithMapNode.querySelector( '.realpress-swm-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			searchWithMapNode.querySelector( '.realpress-swm-from-to' ).innerHTML = res.data.from_to;
		} else {
			searchWithMapNode.querySelector( '.realpress-swm-from-to' ).innerHTML = '';
		}

		const paginationNode = searchWithMapNode.querySelector( '.realpress-pagination' );
		if ( !! paginationNode ) {
			const pageNodes = paginationNode.querySelectorAll( 'a' );
			for ( let i = 0; i < pageNodes.length; i++ ) {
				pageNodes[ i ].addEventListener( 'click', function( event ) {
					event.preventDefault();
					const offset = this.getAttribute( 'data-page' );
					query = { ...query, offset };
					getProperties( query );
					mapPropertyNode.scrollIntoView( { behavior: 'smooth' } );
				} );
			}
		}
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		const urlPush = getUrl( query );
		window.history.pushState( '', '', urlPush );
		containerNode.style.opacity = 1;
	} );
};

const sort = () => {
	sortNode.addEventListener( 'change', function( event ) {
		const paginationNode = searchWithMapNode.querySelector( '.realpress-swm-pagination .realpress-pagination' );
		let offset = 1;
		if ( paginationNode ) {
			offset = paginationNode.querySelector( 'li.current a' ).getAttribute( 'data-page' );
		}
		const selected = event.target.value;
		const sortParams = getOrderParams( selected );
		query = { ...query, ...sortParams, offset };
		getProperties( query );
		mapPropertyNode.scrollIntoView( { behavior: 'smooth' } );
	} );
};

const search = () => {
	const searchButtonNode = searchNode.querySelector( 'button.realpress-search-property-button' );
	searchButtonNode.addEventListener( 'click', function() {
		const fieldNodes = searchNode.querySelectorAll( '.realpress-search-field input,select' );
		if ( ! fieldNodes ) {
			return;
		}

		for ( let i = 0; i < fieldNodes.length; i++ ) {
			const fieldNode = fieldNodes[ i ];
			const name = fieldNode.getAttribute( 'name' );
			if ( fieldNode.value === '' ) {
				if ( query.hasOwnProperty( name ) ) {
					delete query[ name ];
				}
			} else {
				query[ name ] = fieldNode.value;
			}
		}
		query = { ...query, offset: 1 };
		getProperties( query );
		mapPropertyNode.scrollIntoView( { behavior: 'smooth' } );
	} );
};

const handlePropertyMap = ( properties ) => {
	const tileLayer = L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
	} );

	const mapBounds = getMapBounds( properties );
	let mapCenter = null;
	if ( mapBounds.length === 1 ) {
		mapCenter = L.latLng( mapBounds[ 0 ] );
	}

	const mapOptions = {
		dragging: true,
		center: mapCenter,
		zoom: 10,
		tap: false,
		scrollWheelZoom: false,
		zoomSnap: 0.25 // fit map bound
	};

	if ( map !== undefined ) {
		map.remove();
	}

	map = L.map( 'realpress-swm-map-area', mapOptions );
	map.addLayer( tileLayer );
	if ( 1 < mapBounds.length ) {
		map.fitBounds( mapBounds );
	}

	addMarker( properties, map );
};

const triggerPopup = () => {
	const propertyItemNodes = containerNode.querySelectorAll( '.realpress-property-item' );
	if ( ! propertyItemNodes ) {
		return;
	}
	for ( let i = 0; i < propertyItemNodes.length; i++ ) {
		const propertyItemNode = propertyItemNodes[ i ];
		const propertyId = propertyItemNode.getAttribute( 'property-id' );

		propertyItemNode.addEventListener( 'mouseenter', function() {
			openPopup( map, propertyId );
		} );
		propertyItemNode.addEventListener( 'mouseleave', function() {
			closePopup( map, propertyId );
		} );
	}
};

export default realpressSearchWithMap;
